export interface IContractTransfer {
    igsCustomerNumberToTransfer: string;
    newIgsCustomerNumber: string;
    httpResponseMessage: any;
}

export class ContractTransfer implements IContractTransfer {
    igsCustomerNumberToTransfer: string;    
    newIgsCustomerNumber: string;
    httpResponseMessage: any;
}

export interface IContractTransferRequest {
    newCustomersFirstName: string;
    newCustomersMiddleName: string;
    newCustomersLastName: string;
    newCustomersPhoneNumber: string;
    newCustomersEmail: string;
    effectiveDateOfTransfer: Date;
    electronicConsentSignedDate: Date;
    creditAuthorizationSignedDate: Date;
    creditCheckedDate: Date;
    httpResponseMessage: any;
}

export class ContractTransferRequest implements IContractTransferRequest, IContractTransfer {
    igsCustomerNumberToTransfer: string;    
    newIgsCustomerNumber: string;
    newCustomersFirstName: string;
    newCustomersMiddleName: string;
    newCustomersLastName: string;
    newCustomersPhoneNumber: string;
    newCustomersEmail: string;
    effectiveDateOfTransfer: Date;
    electronicConsentSignedDate: Date;
    creditAuthorizationSignedDate: Date;
    creditCheckedDate: Date;
    httpResponseMessage: any;
}